module.exports = function(service) {
	'use strict'
	service.factory('cleanObj', cleanObj);
	cleanObj.$inject = [];
	function cleanObj() {
	   return {
		   	clean : function(obj) {
			   	for (var propName in obj) { 
		    		if (obj[propName] === null || obj[propName] === undefined) {
		      				delete obj[propName];
		    		}
			  	}
	        }
	   }
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/servicesModule/services/cleanObjService.js
// module id = 589
// module chunks = 0